import React from "react";
import "./WipeAllButton.css"; // We will create this CSS file next
import { lang } from "../lang"; // For the button text

function WipeAllButton({ onClick }) {
  return (
    <button
      className="wipe-all-button-component" // Base class for styling
      onClick={onClick}
      title={lang.drawer.wipeAll} // Tooltip text
    >
      {lang.drawer.wipeAll} {/* Button text from lang file */}
    </button>
  );
}

export default WipeAllButton;
